<script>
  // imports --------------------------------------------------------------- //

  import { onMount } from 'svelte';
  import { show_message } from '../lib/flash.ts';
  import UnauthenticatedLayout from '../app-shell/guest-app/Layout.svelte';
  import Messages from './components/Messages.svelte';
  import { APIClient } from '../state-charts';
  import { TS } from '../config/translation-keys';
  import { t9n } from '../lib/translate';
  import LoginRegFormFlip from './LoginRegFormFlip.svelte';
  import session from '../lib/session';

  // component options  ---------------------------------------------------- //

  export let query;

  // local variables ------------------------------------------------------- //

  let login_active = true;
  let register_active = false;
  let registration_data;
  let data;

  // utility functions ----------------------------------------------------- //

  const check_mobile = () => {
    let check = false;
    (function checkmobilenavigator(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    if (check === true) {
      show_message(
        'It seems you are on a mobile browser, please consider using the app, or request the desktop version for the best mobile experience.',
        'info'
      );
    }
  };

  const fix_for_autofill = () => {
    if (navigator.userAgent.indexOf('Chrome') > 0) {
      setTimeout(function() {
        const x = document.querySelectorAll(`
            input:-webkit-autofill + .mdc-notched-outline .mdc-floating-label,
            input:-webkit-autofill + * + .mdc-notched-outline .mdc-floating-label
        `);
        for (let i = 0; i < x.length; i++) {
          x[i].classList.add('mdc-floating-label--float-above');
        }
      }, 1000);

      setTimeout(function() {
        const x = document.querySelectorAll(`
            input:-webkit-autofill + .mdc-notched-outline,
            input:-webkit-autofill + * + .mdc-notched-outline`);
        for (let i = 0; i < x.length; i++) {
          x[i].classList.add('mdc-notched-outline--upgraded');
          x[i].classList.add('mdc-notched-outline--notched');
        }
      }, 1000);
    }
  };

  const check_confirmation = async () => {
    if (query && query.confirmation_code) {
      const result = await APIClient.confirm_email({
        code: query.confirmation_code,
      });

      if (typeof result === 'object' && Object.keys(result).length === 0) {
        show_message(t9n(TS.EMAIL_CONFIRMATION_SUCCESS_MESSAGE), 'success');
      }
    }
  };

  const check_invite = async () => {
    if (query && query.invite_token) {
      let token = query.invite_token;
      registration_data = await APIClient.get_invite_token(token);
    }
  };

  const check_zoom = () => {
    let initial_zoom_level = Math.round(window.devicePixelRatio * 100);
    if (initial_zoom_level > 100) {
      trigger_zoom_changes()
    }
    window.addEventListener("resize", () => {
      const zoom_level = Math.round(window.devicePixelRatio * 100);
      if (zoom_level > 100) {
        trigger_zoom_changes()
      }
    })
  };

  const trigger_zoom_changes = () => {
    let main = document.getElementById('zoom_element');
    if (!!main) {
      if (main.classList.contains('contained-section')) {
        main.classList.remove('contained-section');
        main.classList.add('contained-section-zoomed');
      } else {
        main.classList.remove('contained-section-zoomed');
        main.classList.add('contained-section');
      }
    }
  };

  // initializer functions -------------------------------------------------- //

  const init_login = async () => {
    check_mobile();
    check_zoom();
    fix_for_autofill();
    await check_confirmation();
    await check_invite();
  };

  // lifecycle -------------------------------------------------------------- //

  onMount(async () => await init_login());
</script>

<div id='bg-branding'></div>
<UnauthenticatedLayout>
  <div id="login-page" slot="content" class="container">
    <main id="zoom_element" class="contained-section">
      <!-- Logo -->

      <div style="margin-top: 8px" />

      <section class="main-intro">
        <!-- Login part -->
        <form id="login_container" autocomplete="off" class="left move-out">
          <LoginRegFormFlip data={registration_data} />
        </form>
      </section>

      <!-- Confirm message -->
      <Messages />
    </main>
  </div>
</UnauthenticatedLayout>

<style type="text/scss">

  #bg-branding{
    background-size: cover;
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    transition: all 0.3s ease;
    background-image: url("/assets/orderer_background1.jpg");
  }
  /* Define theme variables before importing any MDC Web component styles */

  html,
  body {
    height: 100%;
  }

  #login-page {
    /*background-size: 100%;*/
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
  }

  :root {
    --pageMax: 1024px;
  }

  /* Base */
  .container {
    /*display: flex;*/
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100vw;
    margin: 0;
    /*padding-bottom: 1em;*/
  }

  .contained-section {
    max-width: var(--pageMax);
    padding: 16px;
    width: calc(100vw - 32px);
    margin: 0 auto;
  }

  .contained-section-zoomed {
    max-width: 100% !important;
    padding: 0px !important;
    width: 100% !important;
    margin: 0 auto;
  }

  .main-intro .horizontal-card .demo-card__primary {
    width: calc(100% - 150px);
  }

  .welcome-padding {
    padding-top: 50px;
  }

  .sign-margin {
    margin-top: -50px;
  }

  .margin-space {
    margin-top: 50px;
  }

  .email-padding {
    padding-top: 20px;
  }

  .confirm-center {
    text-align: center;
  }

  .check-display {
    display: inline-block;
  }

  /* Override line height on body text*/
  .mdc-typography--body2 {
    line-height: 1.8;
  }

  .introText {
    line-height: 1.8;
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
    color: dimgray;
  }

  .logo {
    width: 114px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -50px;
  }

  /* Inputs */
  .mdc-text-field {
    width: 100%;
    margin-bottom: 16px;
  }

  /* Action button container*/
  .actionContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }

  .getHelp {
    margin-right: 16px;
    color: gray;
  }

  .my-card {
    padding-top: 20px;
    padding-left: 30px;
    align-items: flex-start;
    width: 600px;
    border-radius: 10px;
  }

  .fade-in {
    animation: transition_in 3s;
  }

  @media screen and (min-width: 768px) {
    main {
      padding: 32px;
    }

    .main-intro {
      display: flex;
    }

    .left {
      margin-bottom: 0;
      transition: all 2s;
    }

    .left,
    .right {
      width: 100%;
    }

    .right {
      flex-direction: column;
      margin-left: 32px;
      margin-top: 49px;
    }

    .nomobile {
      display: block;
    }

    .mobile {
      /*width: unset;
      height: unset; */
    }
  }

  /* Mobile Mode
   ****************************************************** */
  @media (min-width: 0) and (max-width: 768px) {
    #application {
      display: block;
    }

    #login-page {
      /*background-image: none;*/
    }

    #transition-outer {
      height: 100%;
    }

    .fadeIn {
      opacity: 1;
    }

    .contained-section {
      padding: 10px;
      width: calc(100vw - 27px);
      margin: 0;
    }

    .nomobile {
      display: none;
    }

    .mobile {
      /*width: 42%;
      height: 20%; */
    }
  }
</style>
